<template>
    <div class="user camp-favorite-page camp-member-page">
        <div class="headerbg">
            <b-container class="d-flex align-items-center justify-content-between">
                <h1>{{ title }}</h1>
                <b-button variant="outline-secondary" size="sm" @click="logout">登出</b-button>
            </b-container>
        </div>
        <b-container fluid="xl">
            <b-row>
                <b-col cols="12" md="2" class="member-sidebar-col">
                    <nacUser></nacUser>
                </b-col>
                <b-col cols="12" md="10" class="member-content-col">
                    <b-card class="mb-3">
                        <template #header>
                            <span class="font-weight-bold">營隊收藏</span>
                        </template>
                        <b-alert show variant="light" class="text-center mb-3">
                            目前沒有營隊收藏。
                        </b-alert>
                        <div class="text-center">
                            <b-button variant="primary" @click="_go('/camps')">瀏覽營隊</b-button>
                        </div>
                    </b-card>
                </b-col>
            </b-row>
        </b-container>
    </div>
</template>

<script>
import nacUser from '@/components/nacUser.vue';

export default {
    name: 'CampFavorite',
    components: { nacUser },
    data() {
        return {
            title: '營隊收藏',
        };
    },
    mounted() {
        if (this.IsNull(this._sessionData('TokenID')) == '') {
            alert('請先登入');
            this._go('/');
        }
    },
    methods: {
        logout() {
            const data1 = this._storeData('Header_form1');
            if (this.IsNull(data1) !== '') {
                data1.text = '學員登入';
            }
            this._sessionData('NewToken', '');
            this._sessionData('TokenID', '');
            this._sessionData('campCartCachedCount', '');
            this._sessionData('courseCartCachedCount', '');
            this._go('/');
        },
    },
};
</script>
